import React from "react";
import { useTranslation } from "react-i18next";
import "./LeadersSection.css";

import identity from "../../Assets/identity.png";
import leader1 from "../../Assets/Anna.png";
import leader2 from "../../Assets/MG-Ramachandran.png";
import leader3 from "../../Assets/Jayalalitha.png";

export default function LeadersSection() {
  const { t } = useTranslation();

  return (
    <div className="ls-wrapper">
      <div className="ls-inner">

        {/* Logo + Title */}
        <div className="ls-header">
          <img src={identity} alt={t("leaders_logo_alt")} className="ls-logo" />
          <h2 className="ls-title">
            {t("leaders_section_title")}
          </h2>
        </div>

        {/* Leader Images */}
        <div className="ls-leaders">
          <div className="ls-card">
            <img src={leader1} alt={t("leader_anna_alt")} className="ls-img" />
          </div>

          <div className="ls-card">
            <img src={leader2} alt={t("leader_mgr_alt")} className="ls-img" />
          </div>

          <div className="ls-card">
            <img src={leader3} alt={t("leader_jaya_alt")} className="ls-img" />
          </div>
        </div>

      </div>
    </div>
  );
}
